import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 6.667h-1.333v-2A.666.666 0 0 0 12 4H8.667V2a.667.667 0 1 0-1.334 0v2H4a.667.667 0 0 0-.667.667v2H2a.667.667 0 0 0-.667.666v4A.667.667 0 0 0 2 12h5.333v2a.666.666 0 1 0 1.334 0v-2H14a.667.667 0 0 0 .667-.667v-4A.666.666 0 0 0 14 6.667M4.667 5.333h6.666v1.334H4.667zm8.666 5.334H2.667V8h10.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })